import React, { useEffect, useLayoutEffect, useState } from "react";
import MainLogo from "../Assets/images/MainLogo.png";
import { ReactComponent as IBMainLogo } from "../Assets/svgs/ib-main-logo.svg";
import MainLogo2 from "../Assets/images/footer-logo.png";
import { ReactComponent as BackTriangle } from "../Assets/svgs/back-triangle.svg";
import { ReactComponent as CloseIcon } from "../Assets/svgs/close-icon-info.svg";
import { ReactComponent as PersonIcon } from "../Assets/svgs/person-icon.svg";
import { ReactComponent as DownArrow } from "../Assets/svgs/down-arrow.svg";
import { ReactComponent as ViewProfile } from "../Assets/svgs/view-profile-menu.svg";
import { ReactComponent as HamburgerMenu } from "../Assets/svgs/hamburger-menu.svg";
import { ReactComponent as OrderIcon } from "../Assets/svgs/order-menu-icon.svg";
import { ReactComponent as WishlistIcon } from "../Assets/svgs/wishlist-menu-icon.svg";
import { ReactComponent as ProposalIcon } from "../Assets/svgs/proposals-menu-icon.svg";
import { ReactComponent as HealthTipsIcon } from "../Assets/svgs/healthtips-menu-icon.svg";
import { ReactComponent as SearchIcon } from "../Assets/svgs/search-menu-icon.svg";
import { ReactComponent as OrderingIcon } from "../Assets/svgs/ordering-menu-icon.svg";
import { ReactComponent as DownloadIcon } from "../Assets/svgs/downloading-menu-icon.svg";
import { ReactComponent as LicenseIcon } from "../Assets/svgs/licensing-menu-icon.svg";
import { ReactComponent as TechnicalIcon } from "../Assets/svgs/technical-menu-icon.svg";
import { ReactComponent as LogoutIcon } from "../Assets/svgs/logout-menu-icon.svg";
import { ReactComponent as Wishlist } from "../Assets/svgs/wishlist-menu.svg";
import { ReactComponent as CartMenu } from "../Assets/svgs/cart-menu.svg";
import { ReactComponent as ResearchFormPerson } from "../Assets/svgs/research-form-person.svg";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  Badge,
  Box,
  Drawer,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  GetMainBrowseCategories,
  GetMainVideosCategories,
  GetStarsCollectionCategories,
  GetSubBrowseCategories,
} from "../../services/BrowseCategories";
import { GetAllWishlist } from "../../services/WishListImages";
import { GetAllCartData } from "../../services/Addtocart";
import { useDispatch, useSelector } from "react-redux";
import { homePageDataSelector } from "../../redux/homepage";
import { wishlistDataSelector } from "../../redux/wishlist";
import { cartDataSelector } from "../../redux/cart";
import CustomButton from "./Buttons/CustomButton";
import { loginItemsSelector, setTriggerUiRender } from "../../redux/login";
import { crypt, getDataFromAppSetting } from "../../lib/helper";
import CustomIconButtons from "./Buttons/IconButtons";
import SearchBar from "./SearchBar";
import { appSettingDataSelector } from "../../redux/appSetting";
import ImageMenu from "./ImageMenu";
import Vimeo from "@u-wave/react-vimeo";
import VideoMenu from "./VideoMenu";
import StarsImageMenu from "../Screens/StarContent/StarsImageMenu";
import ConfirmationModal from "../Modals/ConfirmationModal";
import StarsSearchBar from "./StarsSearchBar";
import { LIVE_WEBSITE_URL, S3_BASE_URL } from "../../config/ApiConfig";
import MagnifyImageModal from "../Modals/MagnifyImageModal";
import ContributorSoldImages from "../contributers/ContributorSoldImages/ContributorSoldImages";
import { Helmet } from "react-helmet";

const Header = ({
  authUser,
  isStarsCollectionPage,
  isSearchtext,
  FullImageWall,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { appSettingData } = useSelector(appSettingDataSelector);
  const selectedMenuType = searchParams.get("menu_type");
  const {
    browseCategory,
    subBrowseCategory,
    videosBrowseCategory,
    starsCollectionBrowseCategory,
  } = useSelector(homePageDataSelector);
  const { cartData } = useSelector(cartDataSelector);
  const { wishlistData } = useSelector(wishlistDataSelector);
  const { triggerUiRerender, isPrivilegeUser } =
    useSelector(loginItemsSelector);
  const location = useLocation();
  const [profileDropdownShow, setProfileDropdownShow] = useState(false);
  const [openLeftDrawer, setOpenLeftDrawer] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isOpenMyAccount, setIsOpenMyAccount] = useState(false);
  const [isOpenHealthTips, setIsOpenHealthTips] = useState(false);
  const [openMagnifyImageModal, setOpenMagnifyImageModal] = useState(false);
  const [selectedMagnifyImage, setSelectedMagnifyImage] = useState({});
  const [selectedMainSideMenu, setSelectedMainSideMenu] = useState();
  const [openLeftDrawer2, setOpenLeftDrawer2] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [showTitleHeader, setShowTitleHeader] = useState(true);
  const [titleHeaderHeight, setTitleHeaderHeight] = useState("");
  const [mainLayoutHeader, setMainLayoutHeader] = useState({
    background: "",
    boxShadow: "none",
  });
  const listenScrollEvent2 = () => {
    if (window.scrollY < 31) {
      return setShowTitleHeader(true);
    } else if (window.scrollY > 30) {
      return setShowTitleHeader(false);
    }
  };
  const tabMenu = searchParams.get("tab");
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent2);
    const boxHeight = document.querySelector("#titleBar107");
    if (boxHeight) {
      setTitleHeaderHeight(`${boxHeight.offsetHeight}px`);
    }
    return () => window.removeEventListener("scroll", listenScrollEvent2);
  }, [window.scrollY]);
  useEffect(() => {
    getMainBrowseCategory();
  }, [selectedMenuType]);
  // const logoutUser = (value) => {
  //   if (value) {
  //     localStorage.clear();
  //     window.location.href = "/";
  //   }
  // };
  const logoutUser = () => {
    localStorage.clear();
    window.location.href = "/";
  };
  const getAllWishlistData = async () => {
    if (
      localStorage.getItem("user") !== null &&
      localStorage.getItem("user") !== undefined
    ) {
      dispatch(GetAllWishlist());
    }
  };
  const getAllCartImages = async () => {
    if (
      localStorage.getItem("user") !== null &&
      localStorage.getItem("user") !== undefined &&
      localStorage.getItem("token") !== undefined
    ) {
      dispatch(GetAllCartData());
    }
  };
  const handleOpenMagnifyImage = (imageUrl, imageName, imageShootId) => {
    setOpenMagnifyImageModal(true);
    setSelectedMagnifyImage({
      imageUrl: imageUrl,
      imageName: imageName,
      imageShootId: imageShootId,
    });
  };
  const getMainBrowseCategory = async () => {
    if (
      location?.pathname?.toString()?.includes("video/") ||
      selectedMenuType === "video"
    ) {
      dispatch(GetMainVideosCategories());
    } else if (
      location?.pathname?.toString()?.includes("stars/") ||
      selectedMenuType === "stars" ||
      isStarsCollectionPage === true
    ) {
      dispatch(GetStarsCollectionCategories());
    } else {
      dispatch(GetMainBrowseCategories());
    }
  };
  const handleClick = () => {
    setOpenLeftDrawer(!openLeftDrawer);
  };
  useEffect(() => {
    const userDetails = JSON.parse(localStorage?.getItem("user"));
    setUserDetails(userDetails);
    dispatch(setTriggerUiRender(false));
  }, []);
  const handleCofirmModalOpen = (value) => {
    setConfirmDelete(value);
  };
  useEffect(() => {
    if (triggerUiRerender) {
      const userDetails = JSON.parse(localStorage?.getItem("user"));
      setUserDetails(userDetails);
      dispatch(setTriggerUiRender(false));
      getAllWishlistData();
      getAllCartImages();
    }
  }, [triggerUiRerender]);

  const listenScrollEvent = () => {
    if (window.scrollY < 23) {
      return setMainLayoutHeader({
        background: "",
        boxShadow: "none",
      });
    } else if (window.scrollY > 20) {
      return setMainLayoutHeader({
        background: "white",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
      });
    }
  };
  useLayoutEffect(() => {
    window.addEventListener("scroll", listenScrollEvent2);
    const boxHeight = document.querySelector("#titleBar107");
    if (boxHeight) {
      setTitleHeaderHeight(`${boxHeight.offsetHeight}px`);
    }
    return () => window.removeEventListener("scroll", listenScrollEvent2);
  }, [window.scrollY]);
  const submitMainMenuSelection = async (name, srno) => {
    dispatch(GetSubBrowseCategories(srno));
    setOpenLeftDrawer2(true);
    setSelectedMainSideMenu(name);
    setOpenLeftDrawer(false);
  };
  const list = () => (
    <div className="browse-category-main-drawer">
      <div>
        <div className="close-drawer-menu-btn">
          <button
            className="close-side-drawer-button"
            onClick={() => setOpenLeftDrawer(false)}
          >
            <CloseIcon className="close-side-drawer" />
          </button>
        </div>
        {browseCategory?.items?.map((data, index) => (
          <div
            key={`${index}${data?.name}`}
            className="side-drawer-button-main"
          >
            <CustomButton
              fullWidth
              className="browseCategoryButtonStyle"
              onClick={() => {
                submitMainMenuSelection(data?.name, data?.sno);
              }}
              sx={{
                borderRadius: (theme) => theme.shape.borderRadiusSecondary(15),
              }}
            >
              {/* <Typography
                variant="sectiondata"
                className="browseCategoryButton"
                component="div"
              > */}
              {data?.name}
              {/* </Typography> */}
            </CustomButton>
          </div>
        ))}
      </div>
    </div>
  );
  const list2 = () => (
    <div className="browse-category-main-drawer">
      <div>
        <div>
          <button
            className="close-side-drawer-button back-menu-button"
            onClick={() => {
              setOpenLeftDrawer2(false);
              setOpenLeftDrawer(true);
            }}
          >
            <BackTriangle className="backto-main-menu" />
            <span className="main-menu-side-bar sectiondata">MAIN MENU</span>
          </button>
        </div>
        <div className="side-drawer-button-main">
          <CustomButton
            fullWidth
            className="browseCategoryButtonStyle selectedButton"
            onClick={() => setOpenLeftDrawer2(true)}
            sx={{
              borderRadius: (theme) => theme.shape.borderRadiusSecondary(15),
            }}
          >
            {/* <Typography
              variant="sectiondata"
              component="div"
              className="browseCategoryButton"
            > */}
            {selectedMainSideMenu}
            {/* </Typography> */}
          </CustomButton>
        </div>
        {subBrowseCategory?.items?.map((data, index) => {
          const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
          let resultedString = [];
          let mainItemSearch = "";
          if (data?.name === "View All" || data?.display_name === "View All") {
            resultedString = selectedMainSideMenu?.split(specialChars);
            {
              /* mainItemSearch = resultedString?.join(" "); */
            }
            mainItemSearch = selectedMainSideMenu;
          } else {
            resultedString = data?.name?.split(specialChars);
            {
              /* mainItemSearch = resultedString?.join(" "); */
            }
            mainItemSearch = data?.search_id;
          }

          return (
            <div
              key={`${index}${data?.name}`}
              className="side-drawer-button-main"
            >
              <CustomButton
                fullWidth
                className="browseCategoryButtonStyle"
                onClick={() => {
                  // if (
                  //   location?.pathname?.toString()?.includes("video/") ||
                  //   selectedMenuType === "video"
                  // ) {
                  //   navigate(
                  //     `/video/search/${data?.search_id}?displayKeyword=${crypt(
                  //       "displayKeyword",
                  //       data?.display_name
                  //     )}&br=1`
                  //   );
                  // } else {
                  navigate(
                    `/search/${data?.search_id}?displayKeyword=${crypt(
                      "displayKeyword",
                      data?.display_name
                    )}&br=1`
                  );
                  // }
                  setOpenLeftDrawer2(false);
                }}
                sx={{
                  borderRadius: (theme) =>
                    theme.shape.borderRadiusSecondary(15),
                }}
              >
                {/* <Typography variant="sectiondata" component="div" className="browseCategoryButton"> */}
                {data?.name}
                {/* </Typography> */}
              </CustomButton>
            </div>
          );
        })}
      </div>
    </div>
  );

  const browseCategoryListForVideo = () => (
    <div className="browse-category-main-drawer">
      <div>
        <div className="close-drawer-menu-btn">
          <button
            className="close-side-drawer-button"
            onClick={() => setOpenLeftDrawer(false)}
          >
            <CloseIcon className="close-side-drawer" />
          </button>
        </div>
        {videosBrowseCategory?.items?.map((data, index) => (
          <div
            key={`${index}${data?.name}`}
            className="side-drawer-button-main"
          >
            <CustomButton
              fullWidth
              className="browseCategoryButtonStyle"
              onClick={() => {
                navigate(
                  `/video/search/${data?.search_id}?displayKeyword=${crypt(
                    "displayKeyword",
                    data?.display_name
                  )}&br=1`
                );
                setOpenLeftDrawer(false);
              }}
              sx={{
                borderRadius: (theme) => theme.shape.borderRadiusSecondary(15),
              }}
            >
              {/* <Typography
                variant="sectiondata"
                className="browseCategoryButton"
                component="div"
              > */}
              {data?.category_name}
              {/* </Typography> */}
            </CustomButton>
          </div>
        ))}
      </div>
    </div>
  );

  const browseCategoryListForStarsCollection = () => (
       <div className="browse-category-main-drawer stars-collection-category">
      <div>
        <div className="close-drawer-menu-btn">
          <button
            className="close-side-drawer-button"
            onClick={() => setOpenLeftDrawer(false)}
          >
            <CloseIcon className="close-side-drawer" />
          </button>
        </div>
        {starsCollectionBrowseCategory?.items?.map((data, index) => (
          <div
            key={`${index}${data?.name}`}
            className="side-drawer-button-main"
          >
            <CustomButton
              fullWidth
              className="browseCategoryButtonStyle"
              onClick={() => {
                navigate(
                  `/stars/search/${data?.search_id}?displayKeyword=${crypt(
                    "displayKeyword",
                    data?.display_name
                  )}&br=1`
                );
                setOpenLeftDrawer(false);
              }}
              sx={{
                borderRadius: (theme) => theme.shape.borderRadiusSecondary(15),
                // justifyContent: "center !important",
              }}
            >
              {/* <Typography
                variant="sectiondata"
                className="browseCategoryButton"
                component="div"
              > */}
              {data?.category_name}
              {/* </Typography> */}
            </CustomButton>
          </div>
        ))}
      </div>
    </div>
  );
  return (
    <>
      {location?.search ? (
        ""
      ) : (
        <Helmet>
          <title>
            Imagesbazaar : Largest Collection of Indian Images and Videos
          </title>
          <meta
            name="description"
            content="Why ImagesBazaar?
      India's diversity and complexity can be witnessed through its people, traditions and values associated with distinctive regional customs, habits, lifestyle and festivals. That's why our content reflects the innate expressions of deep-rooted feelings of individuals through which spring their day-to-day actions. From contemporary concepts and ideas to the broadest range of categories depicting Indians in virtually all walks of life, age groups and expressions - you will find it all here!"
          />
          <meta property="og:title" content="Imagesbazaar : Largest Collection of Indian Images and Videos" />
          <meta
            property="og:description"
            content="Why ImagesBazaar?
             India's diversity and complexity can be witnessed through its people, traditions and values associated with distinctive regional customs, habits, lifestyle and festivals. That's why our content reflects the innate expressions of deep-rooted feelings of individuals through which spring their day-to-day actions. From contemporary concepts and ideas to the broadest range of categories depicting Indians in virtually all walks of life, age groups and expressions - you will find it all here!"
          />
          <meta property="og:url" content={LIVE_WEBSITE_URL} />
        </Helmet>
      )}
      {openMagnifyImageModal && (
        <MagnifyImageModal
          open={openMagnifyImageModal}
          zoomImage={FullImageWall}
          onClose={() => setOpenMagnifyImageModal(false)}
          selectedMagnifyImage={selectedMagnifyImage}
        />
      )}
      <Drawer
        anchor="left"
        className="browse-cat-side-drawer"
        open={openLeftDrawer}
        onClose={() => setOpenLeftDrawer(false)}
      >
        {location?.pathname?.toString()?.includes("video/") ||
        selectedMenuType === "video"
          ? browseCategoryListForVideo()
          : location?.pathname?.toString()?.includes("stars/") ||
            selectedMenuType === "stars" ||
            isStarsCollectionPage === true
          ? browseCategoryListForStarsCollection()
          : list()}
      </Drawer>
      <Drawer
        anchor="left"
        className="browse-cat-side-drawer"
        open={openLeftDrawer2}
        onClose={() => {
          setOpenLeftDrawer2(false);
          setOpenLeftDrawer(false);
        }}
      >
        {list2()}
      </Drawer>
      <Box component="div" className="mainHeader-layout">
        <Box
          component="div"
          id="titleBar107"
          className="mainHeader-titleBar-layout"
          sx={{}}
        >
          <Box
            component="div"status
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <IconButton sx={{ padding: "6px" }} onClick={handleClick}>
              <HamburgerMenu fill="black" width="20px" height="20px" />
            </IconButton>
            <Typography
              variant="mainpagetitle"
              sx={{ marginLeft: "10px" }}
              className="mainpagetitle-bolder primaryColor header-menus"
              component="div"
              onClick={handleClick}
            >
              Browse Categories
            </Typography>
          </Box>
          <Box
            component="div"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Link
              to={
                tabMenu !== "stars" &&
                !location?.pathname?.toString()?.includes("stars/")
                  ? "/"
                  : "/stars/"
              }
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IBMainLogo className="ib-main-logo" />
              {/* <img className="main-logo" src={MainLogo} alt="MainLogo" /> */}
            </Link>
          </Box>
          <Box
            component="div"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {authUser === true ? (
              <>
                <div className="header-right-content">
                  {isStarsCollectionPage == true ? (
                    <></>
                  ) : (
                    <Typography
                      variant="mainpagetitle"
                      className="mainpagetitle-bolder primaryColor margin-r-10 header-menus"
                      component="div"
                      onClick={() => navigate("/pricing")}
                    >
                      Pricing
                    </Typography>
                  )}
                  <div className="wishlist-header-notification">
                    <Tooltip title="Wishlist" arrow placement="bottom">
                      <button
                        className="wishlist-notification-button"
                        onClick={() => navigate("/wishlist")}
                      >
                        <Badge
                          color="secondary"
                          badgeContent={wishlistData?.items?.totalCount}
                          max={99}
                        >
                          <Wishlist className="wishlist-items-notification" />
                        </Badge>
                      </button>
                    </Tooltip>
                  </div>
                  <div className="wishlist-header-notification">
                    <Tooltip title="Shopping Cart" arrow placement="bottom">
                      <button
                        className="wishlist-notification-button"
                        onClick={() => navigate("/viewcart")}
                      >
                        <Badge
                          color="secondary"
                          badgeContent={cartData?.items?.cart?.length}
                          max={99}
                        >
                          <CartMenu className="wishlist-items-notification" />
                        </Badge>
                      </button>
                    </Tooltip>
                  </div>
                  <div
                    onMouseEnter={() => setProfileDropdownShow(true)}
                    onMouseLeave={() => setProfileDropdownShow(false)}
                  >
                    <div>
                      <button
                        className="user-textmobile-button"
                        onClick={() =>
                          setProfileDropdownShow(!profileDropdownShow)
                        }
                      >
                        <ResearchFormPerson className="mobile-menu-icon" />
                      </button>
                      <Typography
                        variant="mainpagetitle"
                        className="mainpagetitle-bolder primaryColor user-name-text"
                        component="div"
                      >
                        {`${userDetails?.first_name || "User"} ${
                          userDetails?.last_name || "User"
                        }`}
                      </Typography>
                      {/* <div className="user-name-text"></div> */}
                      {profileDropdownShow ? (
                        <div className="profile-dropdown-list mainsectiontitle">
                          <div className="account-menu-group">
                            <div>
                              <button
                                className="main-account-menu-buttton"
                                onClick={() =>
                                  setIsOpenMyAccount(!isOpenMyAccount)
                                }
                              >
                                <PersonIcon className="account-menu-icnos" />
                                <span className="main-account-menu-name">
                                  My Account
                                </span>
                                <DownArrow
                                  className={`account-menu-down-icon ${
                                    isOpenMyAccount === true
                                      ? "transform-arrow-button"
                                      : ""
                                  }`}
                                />
                              </button>
                            </div>
                            {isOpenMyAccount ? (
                              <div className="submenu-profile-items">
                                <button
                                  className="main-account-menu-buttton"
                                  onClick={() => navigate("/account")}
                                >
                                  <ViewProfile className="account-menu-icnos" />
                                  <span className="main-account-menu-name">
                                    View Profile
                                  </span>
                                </button>
                                <button
                                  className="main-account-menu-buttton"
                                  onClick={() => navigate("/orders")}
                                >
                                  <OrderIcon className="account-menu-icnos" />
                                  <span className="main-account-menu-name">
                                    Orders
                                  </span>
                                </button>
                                <button
                                  className="main-account-menu-buttton"
                                  onClick={() => navigate("/wishlist")}
                                >
                                  <WishlistIcon className="account-menu-icnos" />
                                  <span className="main-account-menu-name">
                                    Wish list
                                  </span>
                                </button>
                                {/* <button
                                  className="main-account-menu-buttton"
                                  onClick={() => navigate("/ShowAllProposal")}
                                >
                                  <ProposalIcon className="account-menu-icnos" />
                                  <span className="main-account-menu-name">
                                    Proposals
                                  </span>
                                </button> */}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="account-menu-group">
                            <div>
                              <button
                                className="main-account-menu-buttton"
                                onClick={() =>
                                  setIsOpenHealthTips(!isOpenHealthTips)
                                }
                              >
                                <HealthTipsIcon className="account-menu-icnos" />
                                <span className="main-account-menu-name">
                                  Help Tips
                                </span>
                                <DownArrow
                                  className={`account-menu-down-icon ${
                                    isOpenHealthTips === true
                                      ? "transform-arrow-button"
                                      : ""
                                  }`}
                                />
                              </button>
                            </div>
                            {isOpenHealthTips ? (
                              <div className="submenu-profile-items">
                                <button
                                  className="main-account-menu-buttton"
                                  onClick={() => navigate("/searchtips")}
                                >
                                  <SearchIcon className="account-menu-icnos" />
                                  <span className="main-account-menu-name">
                                    Search Tips
                                  </span>
                                </button>
                                <button
                                  className="main-account-menu-buttton"
                                  onClick={() => navigate("/ordering")}
                                >
                                  <OrderingIcon className="account-menu-icnos" />
                                  <span className="main-account-menu-name">
                                    Ordering
                                  </span>
                                </button>
                                <button
                                  className="main-account-menu-buttton"
                                  onClick={() => navigate("/downloading")}
                                >
                                  <DownloadIcon className="account-menu-icnos" />
                                  <span className="main-account-menu-name">
                                    Downloading
                                  </span>
                                </button>
                                <button
                                  className="main-account-menu-buttton"
                                  onClick={() => navigate("/licensing")}
                                >
                                  <LicenseIcon className="account-menu-icnos" />
                                  <span className="main-account-menu-name">
                                    Licensing
                                  </span>
                                </button>
                                <button
                                  className="main-account-menu-buttton"
                                  onClick={() => navigate("/technical")}
                                >
                                  <TechnicalIcon className="account-menu-icnos" />
                                  <span className="main-account-menu-name">
                                    Technical
                                  </span>
                                </button>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            <div>
                              <button
                                className="main-account-menu-buttton logout-button-menu"
                                onClick={() => logoutUser()}
                              >
                                <LogoutIcon className="account-menu-icnos" />
                                <span className="main-account-menu-name">
                                  Logout
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {isStarsCollectionPage == true ? (
                  <></>
                ) : (
                  <Typography
                    variant="mainpagetitle"
                    className="mainpagetitle-bolder primaryColor margin-r-10 header-menus"
                    component="div"
                    onClick={() => navigate("/pricing")}
                  >
                    Pricing
                  </Typography>
                )}
                <div>
                  <CustomButton
                    fullWidth
                    className="commonButtonStyles"
                    onClick={() => navigate(`/signin`)}
                    sx={{
                      borderRadius: (theme) =>
                        theme.shape.borderRadiusSecondary(15),
                      padding: "10px 20px",
                      "@media only screen and (min-width: 280px) and (max-width: 749px)":
                        {
                          padding: "7px 15px",
                        },
                    }}
                  >
                    <Typography
                      variant="mainsectiontitle"
                      component="div"
                      className="font-white"
                    >
                      Sign In
                    </Typography>
                  </CustomButton>
                </div>
              </>
            )}
          </Box>
        </Box>
        {isSearchtext && (
          <Box
            component="div"
            className={`${
              showTitleHeader === false
                ? "animation-transform"
                : "mainHeader-searchbar-layout animation-transform"
            }`}
            sx={{
              transform:
                showTitleHeader === true
                  ? ""
                  : `translateY(-${titleHeaderHeight})`,
              backgroundColor: showTitleHeader === true ? "#0000" : `#e7eef7`,
              position: "fixed",
              zIndex: 3,
              padding: "10px 0",
              width: "100%",
              left: 0,
            }}
          >
            {isStarsCollectionPage === true ? (
              <StarsSearchBar
                isSearchtext={isSearchtext}
                animationDropDownStyle={
                  showTitleHeader === true ? {} : { top: 50 }
                }
                animationStyle={showTitleHeader === true ? {} : { height: 30 }}
              />
            ) : (
              <SearchBar
                isSearchtext={isSearchtext}
                showTitleHeader={showTitleHeader}
                animationDropDownStyle={
                  showTitleHeader === true ? {} : { top: 50 }
                }
                animationStyle={showTitleHeader === true ? {} : { height: 30 }}
              />
            )}
          </Box>
        )}
      </Box>
      {/* {confirmDelete && (
        <ConfirmationModal
          open={confirmDelete}
          handleConfirm={logoutUser}
          setOpen={handleCofirmModalOpen}
        />
      )} */}
    </>
  );
};

export default Header;
